import React, { useEffect, useState } from "react";
import { useAppContext } from "../AppContext"; // Adjust the path as needed
import axios from "axios";
import DeliveryOrdersGet from "./DeliveryOrdersComps/DeliveryOrdersGet";

export default function DeliveryOrdersMP() {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <a
        style={{
          marginTop: 20,
          fontSize: 20,
          fontWeight: 500,
        }}
      >
        Orders Page
      </a>
      <DeliveryOrdersGet />
    </div>
  );
}
